export default __webpack_public_path__ + "static/media/logo1.a50a8075.png";